// import { API_URL } from '../../constant';
import React, {useEffect} from 'react';
import "./Bank.css";

import CENA from "../../images/bank/Bank_Central_Asia.png";
import BMRI from "../../images/bank/Bank_Mandiri.png";
import BBBA from "../../images/bank/Bank_Permata.png";
import BNIN from "../../images/bank/BNI.png";
import BRIN from "../../images/bank/BRI.png";
import BNIA from "../../images/bank/CIMB.png";
import BDIN from "../../images/bank/Danamon.png";
import HNBN from "../../images/bank/KEB-Hana.png";
import IBBK from "../../images/bank/Maybank.png";


let Bank = (props)=>{

    const changeIsOpenBank = (val) => {
        props.changeIsOpenBank(val)
    }

    const ClickBank = (code, name) =>{
        props.setBank(code, name)
        changeIsOpenBank(false);
    }

    
    useEffect(()=>{
    },[]);
    return (
        <div className='bank-container'>
            <div className="bank-flex" onClick={()=> ClickBank("CENA", "Bank Central Asia") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={CENA} style={{ "width":"50px" }} alt="Bank Central Asia"/>
                </div>
                <div className='bank-name'>Bank Central Asia</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BMRI", "Bank Mandiri") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BMRI} style={{ "width":"50px" }} alt="Bank Mandiri"/>
                </div>
                <div className='bank-name'>Bank Mandiri</div>
                {/* <div className='bank-price'>Rp. 5.000,-</div> */}
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BBBA", "Bank Permata") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BBBA} style={{ "width":"50px" }} alt="Bank Permata" />
                </div>
                <div className='bank-name'>Bank Permata</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BNIN", "Bank Nasional Indonesia") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BNIN} style={{ "width":"50px" }} alt="Bank Nasional Indonesia"/>
                </div>
                <div className='bank-name'>Bank Nasional Indonesia</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BRIN", "Bank Rakyat Indonesia") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BRIN} style={{ "width":"50px" }} alt="Bank Rakyat Indonesia" />
                </div>
                <div className='bank-name'>Bank Rakyat Indonesia</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BNIA", "CIMB Niaga") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BNIA} style={{ "width":"50px" }} alt="CIMB Niaga"/>
                </div>
                <div className='bank-name'>CIMB Niaga</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("BDIN", "Bank Danamon") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={BDIN} style={{ "width":"50px" }} alt="Bank Danamon"/>
                </div>
                <div className='bank-name'>Bank Danamon</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("HNBN", "Bank KEB Hana") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={HNBN} style={{ "width":"50px" }} alt="Bank KEB Hana"/>
                </div>
                <div className='bank-name'>Bank KEB Hana</div>
            </div>
            <div className="bank-flex" onClick={()=> ClickBank("IBBK", "Bank Maybank") }>
                <div style={{ "padding":"5px", "paddingRight": "10px" }}>
                    <img src={IBBK} style={{ "width":"50px" }} alt="Bank MayBank"/>
                </div>
                <div className='bank-name'>Bank Maybank</div>
            </div>
        </div>
    );
}

export default Bank;